import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  components: {
    Pagination: Pagination
  },
  props: {
    apiName: {
      type: String,
      default: ""
    },
    tabsIndex: {
      type: Number,
      default: 0
    },
    topTabsIndex: {
      type: Number,
      default: 0
    },
    conditions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ["update:totalNum"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //来源标示


    var source = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_source; // 列表请求参数

    var Data = reactive({
      listParams: {
        pageIndex: 1,
        pageSize: 10
      },
      total: 0,
      listData: [],
      options: [{
        label: "未完成",
        value: "0",
        class: "staprimary"
      }, {
        label: "自评完成",
        value: "1",
        class: "stapublish"
      }, {
        label: "考核完成",
        value: "2",
        class: "stastart"
      }, {
        label: "已过期",
        value: "3",
        class: "stacancle"
      }]
    }); // 分页初始化

    function initData() {
      Data.listParams.pageIndex = 1;
      Data.total = 0;
      getTabledata();
    }

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 获取分页返回值：点击的第n页


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var page, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                page = Data.listParams;

                if (props.topTabsIndex == 0) {
                  page['state'] = props.tabsIndex + 1;
                } else if (props.topTabsIndex == 1) {
                  page['state'] = undefined;
                  page['type'] = props.tabsIndex;
                }

                _context3.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[props.apiName](Object.assign(page, props.conditions));

              case 4:
                res = _context3.sent;

                if (res.code == 0) {
                  Data.listData = res.data;
                  Data.total = res.total;

                  if (props.tabsIndex == 0) {
                    emit("update:totalNum", res.total);
                  }
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getTabledata.apply(this, arguments);
    }

    var changPage = function changPage(val) {
      Data.listParams.pageIndex = val;
      getTabledata();
    }; // 查看详情


    var handleDetail = function handleDetail(item) {
      // 查看自评历史
      if (props.topTabsIndex == 0) {
        router.push({
          path: "/personal/AnnualDetail",
          query: {
            listId: item.listId,
            recordId: item.recordId,
            state: item.state,
            title: item.title
          }
        });
      } // 查看考核历史


      if (props.topTabsIndex == 1) {
        router.push({
          path: "/personal/AnnualBeforeDetail",
          query: {
            listId: item.listId,
            recordId: item.recordId,
            state: item.state,
            title: item.title,
            history: props.tabsIndex
          }
        });
      }
    }; // 开始自评/考核


    var handleStart = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var state, _state;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(props.topTabsIndex == 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 3;
                return handleStartTime(item);

              case 3:
                state = _context.sent;

                if (!(state == false)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", false);

              case 8:
                router.push({
                  path: "/personal/AnnualDetail",
                  query: {
                    listId: item.listId,
                    recordId: item.recordId,
                    state: item.state,
                    title: item.title
                  }
                });

              case 9:
                if (!(props.topTabsIndex == 1)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 12;
                return handleStartTime(item);

              case 12:
                _state = _context.sent;

                if (!(_state == false)) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", false);

              case 17:
                router.push({
                  path: "/personal/AnnualBeforeDetail",
                  query: {
                    listId: item.listId,
                    state: item.state,
                    title: item.title,
                    history: props.tabsIndex
                  }
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleStart(_x) {
        return _ref2.apply(this, arguments);
      };
    }(); // 判断是否到达评测时间


    var handleStartTime = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEvaluationIsStart"]({
                  listId: item.listId
                });

              case 2:
                res = _context2.sent;

                if (!(res.msg == "未到开始时间")) {
                  _context2.next = 8;
                  break;
                }

                ElMessage.error("\u672A\u5230\u5F00\u59CB\u65F6\u95F4");
                return _context2.abrupt("return", false);

              case 8:
                return _context2.abrupt("return", true);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleStartTime(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      Data: Data,
      source: source,
      // 查看详情
      handleDetail: handleDetail,
      //  开始自评/考核
      handleStart: handleStart,
      // 获取详情
      getTabledata: getTabledata,
      // 获取分页返回值：点击的第n页
      changPage: changPage,
      initData: initData
    };
  }
});